__webpack_require__.p = "/languages-data/onboarding/";